import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { HeaderDesktop } from './desktop';
import { HeaderMobile } from './mobile';

export interface HeaderProps {
  handleOpenInfo: () => void;
  isOpened: boolean;
  title: string;
  currentValue: string;
}

export const Header: React.FC<HeaderProps> = (props) => {
  const responsiveHeader = useBreakpointValue({
    base: <HeaderMobile {...props} />,
    sm: <HeaderDesktop {...props} />,
  });

  return responsiveHeader;
};
